import { tokens } from '@fluentui/react-theme';
import { __styles, mergeClasses, shorthands } from '@griffel/react';
import { DURATION_2, EASING_FUNCTION_2, FADE_IN } from '../../utils/animations';
/**
 * @internal
 */
export const calendarDayClassNames = {
  root: 'fui-CalendarDay',
  header: 'fui-CalendarDay__header',
  monthAndYear: 'fui-CalendarDay__monthAndYear',
  monthComponents: 'fui-CalendarDay__monthComponents',
  headerIconButton: 'fui-CalendarDay__headerIconButton',
  disabledStyle: 'fui-CalendarDay__disabledStyle'
};
const useRootStyles = /*#__PURE__*/__styles({
  base: {
    B7ck84d: "f1e4lqlz",
    Byoj8tv: 0,
    uwmqm3: 0,
    z189sj: 0,
    z8tnut: 0,
    B0ocmuz: "f1sy4kr4",
    a9b677: "f4m2ahc"
  },
  normalize: {
    E5pizo: "f1couhl3",
    B7ck84d: "f1ewtqcl",
    jrapky: 0,
    Frg6f3: 0,
    t21cq0: 0,
    B6of3ja: 0,
    B74szlk: "f1s184ao",
    Byoj8tv: 0,
    uwmqm3: 0,
    z189sj: 0,
    z8tnut: 0,
    B0ocmuz: "f1mk8lai"
  },
  showWeekNumbers: {
    a9b677: "fl524qk"
  }
}, {
  d: [".f1e4lqlz{box-sizing:content-box;}", [".f1sy4kr4{padding:12px;}", {
    p: -1
  }], ".f4m2ahc{width:196px;}", ".f1couhl3{box-shadow:none;}", ".f1ewtqcl{box-sizing:border-box;}", [".f1s184ao{margin:0;}", {
    p: -1
  }], [".f1mk8lai{padding:0;}", {
    p: -1
  }], ".fl524qk{width:226px;}"]
});
const useHeaderStyles = /*#__PURE__*/__styles({
  base: {
    mc9l5x: "ftuwxu6",
    Bqenvij: "fxldao9",
    Bg96gwp: "f1vzymgo",
    qhf8xq: "f10pi13n",
    a9b677: "fly5x3f"
  }
}, {
  d: [".ftuwxu6{display:inline-flex;}", ".fxldao9{height:28px;}", ".f1vzymgo{line-height:44px;}", ".f10pi13n{position:relative;}", ".fly5x3f{width:100%;}"]
});
const useMonthAndYearStyles = /*#__PURE__*/__styles({
  base: {
    Bt984gj: "f122n59",
    De3pzq: "f1c21dwh",
    icvyot: "f1ern45e",
    vrafjx: ["f1n71otn", "f1deefiw"],
    oivjwe: "f1h8hb77",
    wvpqe5: ["f1deefiw", "f1n71otn"],
    Beyfa6y: 0,
    Bbmb7ep: 0,
    Btl43ni: 0,
    B7oj6ja: 0,
    Dimara: "ft85np5",
    sj55zd: "f19n0e5",
    mc9l5x: "f14t3ns0",
    Bh6795r: "fqerorx",
    Bahqtrf: "f1mo0ibp",
    Be2twd7: "fkhj508",
    Bhrd7zp: "fl43uef",
    Bg96gwp: "f336tjw",
    B68tc82: 0,
    Bmxbyg5: 0,
    Bpg54ce: "f1a3p1vp",
    Byoj8tv: 0,
    uwmqm3: 0,
    z189sj: 0,
    z8tnut: 0,
    B0ocmuz: ["f1td8mcv", "f1udkdxo"],
    fsow6f: ["f1o700av", "fes3tcz"],
    ygn44y: "f1cmbuwj",
    Huce71: "fz5stix"
  },
  animation: {
    vin17d: "fhsqnsn",
    Bf5fcs: "fywypte",
    Bv12yb3: "f1h7u52p",
    Ezkn3b: "fjq4c94"
  },
  headerIsClickable: {
    Jwef8y: "f18a0fwf",
    Bi91k9c: "f3sdaeg",
    eoavqd: "f8491dx",
    pugfm4: 0,
    ukgb2i: 0,
    Dwtyhm: 0,
    Biisq0s: "f15rpok4",
    iro3zm: "f1wvkgvo",
    B2d53fq: "f1wdoaqd",
    c3iz72: "f13c0t7h",
    mghro0: 0,
    Bx68yb: 0,
    syojd9: 0,
    E5hylx: "fy2scak"
  }
}, {
  d: [".f122n59{align-items:center;}", ".f1c21dwh{background-color:var(--colorTransparentBackground);}", ".f1ern45e{border-top-style:none;}", ".f1n71otn{border-right-style:none;}", ".f1deefiw{border-left-style:none;}", ".f1h8hb77{border-bottom-style:none;}", [".ft85np5{border-radius:var(--borderRadiusMedium);}", {
    p: -1
  }], ".f19n0e5{color:var(--colorNeutralForeground1);}", ".f14t3ns0{display:inline-block;}", ".fqerorx{flex-grow:1;}", ".f1mo0ibp{font-family:inherit;}", ".fkhj508{font-size:var(--fontSizeBase300);}", ".fl43uef{font-weight:var(--fontWeightSemibold);}", ".f336tjw{line-height:28px;}", [".f1a3p1vp{overflow:hidden;}", {
    p: -1
  }], [".f1td8mcv{padding:0 4px 0 10px;}", {
    p: -1
  }], [".f1udkdxo{padding:0 10px 0 4px;}", {
    p: -1
  }], ".f1o700av{text-align:left;}", ".fes3tcz{text-align:right;}", ".f1cmbuwj{text-overflow:ellipsis;}", ".fz5stix{white-space:nowrap;}", ".fhsqnsn{animation-duration:0.267s;}", ".fywypte{animation-fill-mode:both;}", ".f1h7u52p{animation-name:f5j8bii;}", ".fjq4c94{animation-timing-function:cubic-bezier(.1,.25,.75,.9);}"],
  k: ["@keyframes f5j8bii{from{opacity:0;}to{opacity:1;}}"],
  h: [".f18a0fwf:hover{background-color:var(--colorBrandBackgroundInvertedHover);}", ".f3sdaeg:hover{color:var(--colorBrandForegroundOnLightHover);}", ".f8491dx:hover{cursor:pointer;}", [".f15rpok4:hover{outline:1px solid var(--colorTransparentStroke);}", {
    p: -1
  }], ".f1wvkgvo:hover:active{background-color:var(--colorBrandBackgroundInvertedPressed);}", ".f1wdoaqd:hover:active{color:var(--colorBrandForegroundOnLightPressed);}", ".f13c0t7h:hover:active{cursor:pointer;}", [".fy2scak:hover:active{outline:1px solid var(--colorTransparentStroke);}", {
    p: -1
  }]]
});
const useMonthComponentsStyles = /*#__PURE__*/__styles({
  base: {
    qb2dma: "fpydfdc",
    mc9l5x: "ftuwxu6"
  }
}, {
  d: [".fpydfdc{align-self:flex-end;}", ".ftuwxu6{display:inline-flex;}"]
});
const useHeaderIconButtonStyles = /*#__PURE__*/__styles({
  base: {
    De3pzq: "f1c21dwh",
    icvyot: "f1ern45e",
    vrafjx: ["f1n71otn", "f1deefiw"],
    oivjwe: "f1h8hb77",
    wvpqe5: ["f1deefiw", "f1n71otn"],
    Beyfa6y: 0,
    Bbmb7ep: 0,
    Btl43ni: 0,
    B7oj6ja: 0,
    Dimara: "ft85np5",
    sj55zd: "f11d4kpn",
    mc9l5x: "ftgm304",
    Bahqtrf: "f1mo0ibp",
    Be2twd7: "fy9rknc",
    Bqenvij: "fxldao9",
    Bg96gwp: "f336tjw",
    B68tc82: 0,
    Bmxbyg5: 0,
    Bpg54ce: "f1gl81tg",
    Byoj8tv: 0,
    uwmqm3: 0,
    z189sj: 0,
    z8tnut: 0,
    B0ocmuz: "f1mk8lai",
    qhf8xq: "f10pi13n",
    fsow6f: "f17mccla",
    a9b677: "f1w9dchk",
    Jwef8y: "f18a0fwf",
    Bi91k9c: "f3sdaeg",
    eoavqd: "f8491dx",
    pugfm4: 0,
    ukgb2i: 0,
    Dwtyhm: 0,
    Biisq0s: "f15rpok4",
    iro3zm: "f1wvkgvo",
    B2d53fq: "f1wdoaqd"
  }
}, {
  d: [".f1c21dwh{background-color:var(--colorTransparentBackground);}", ".f1ern45e{border-top-style:none;}", ".f1n71otn{border-right-style:none;}", ".f1deefiw{border-left-style:none;}", ".f1h8hb77{border-bottom-style:none;}", [".ft85np5{border-radius:var(--borderRadiusMedium);}", {
    p: -1
  }], ".f11d4kpn{color:var(--colorNeutralForeground3);}", ".ftgm304{display:block;}", ".f1mo0ibp{font-family:inherit;}", ".fy9rknc{font-size:var(--fontSizeBase200);}", ".fxldao9{height:28px;}", ".f336tjw{line-height:28px;}", [".f1gl81tg{overflow:visible;}", {
    p: -1
  }], [".f1mk8lai{padding:0;}", {
    p: -1
  }], ".f10pi13n{position:relative;}", ".f17mccla{text-align:center;}", ".f1w9dchk{width:28px;}"],
  h: [".f18a0fwf:hover{background-color:var(--colorBrandBackgroundInvertedHover);}", ".f3sdaeg:hover{color:var(--colorBrandForegroundOnLightHover);}", ".f8491dx:hover{cursor:pointer;}", [".f15rpok4:hover{outline:1px solid var(--colorTransparentStroke);}", {
    p: -1
  }], ".f1wvkgvo:hover:active{background-color:var(--colorBrandBackgroundInvertedPressed);}", ".f1wdoaqd:hover:active{color:var(--colorBrandForegroundOnLightPressed);}"]
});
const useDisabledStyleStyles = /*#__PURE__*/__styles({
  base: {
    Bg33ivm: "f1oelgmz",
    t69wg0: "fhh1ekj"
  }
}, {
  d: [".f1oelgmz,.f1oelgmz:disabled,.f1oelgmz button{color:var(--colorNeutralForegroundDisabled);}", ".fhh1ekj,.fhh1ekj:disabled,.fhh1ekj button{pointer-events:none;}"]
});
/**
 * @internal
 *
 * Apply styling to the CalendarDay slots based on the state
 */
export const useCalendarDayStyles_unstable = props => {
  'use no memo';

  const rootStyles = useRootStyles();
  const headerStyles = useHeaderStyles();
  const monthAndYearStyles = useMonthAndYearStyles();
  const monthComponentsStyles = useMonthComponentsStyles();
  const headerIconButtonStyles = useHeaderIconButtonStyles();
  const disabledStyleStyles = useDisabledStyleStyles();
  const {
    className,
    headerIsClickable,
    showWeekNumbers
  } = props;
  return {
    root: mergeClasses(calendarDayClassNames.root, rootStyles.normalize, rootStyles.base, showWeekNumbers && rootStyles.showWeekNumbers, className),
    header: mergeClasses(calendarDayClassNames.header, headerStyles.base),
    monthAndYear: mergeClasses(calendarDayClassNames.monthAndYear, monthAndYearStyles.base, monthAndYearStyles.animation, headerIsClickable && monthAndYearStyles.headerIsClickable),
    monthComponents: mergeClasses(calendarDayClassNames.monthComponents, monthComponentsStyles.base),
    headerIconButton: mergeClasses(calendarDayClassNames.headerIconButton, headerIconButtonStyles.base),
    disabledStyle: mergeClasses(calendarDayClassNames.disabledStyle, disabledStyleStyles.base)
  };
};